<template>
    <div class="layout">
        <MfaBar />
        <v-main class="nav-panel">
            <router-view />
        </v-main>
    </div>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
</style>

<script lang="js">
import MfaBar from './MfaBar.vue';

export default {
    components : {
        MfaBar
    }
}
</script>